<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</h2>
                <h3 class="subtitle h3 light mb-3 ">{{ $t('nuevo_abono.varios_asientos') }}</h3>
                <button 
                    @click="volver" 
                    class="h6 button small-button mr-0" 
                    :disabled="disabled"
                > 
                    <i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}
                </button>
            </div>
            <div class="col-12 col-lg-4">
                <div class="oswald text-uppercase">{{ $t('nuevo_abono.zona_seleccionada') }}:</div>
                <span class="h3 mb-4 mb-lg-2 d-flex justify-content-between align-items-end">
                    {{ zona.name }}
                </span>
                <ImagenPanoramica 
                    v-if="zona.imagen_panoramica" 
                    name="imagen-panoramica" 
                    :url="zona.imagen_panorama" 
                    title="Imagen panorámica de la zona" 
                    v-on:close="() => close()"
                />
                <div v-if="zona.imagen" class="mb-3">
                    <img v-lazy="zona.imagen"/>
                </div>
                <button 
                    v-if="zona.imagen_panoramica" 
                    @click="showModal('imagen-panoramica')" 
                    type="button" 
                    class="h6 button small-button m-0 mrgn_360"
                >
                    VER 360º
                </button>

                <slot name="asientos-seleccionados"></slot>
            </div>
            <div class="col-12 col-lg-8 order-first order-lg-last">
                <slot name="seat-map"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import ImagenPanoramica from "@/components/common/ImagenPanoramica";

    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            zona: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                n_abonos: 1,
                options: [1, 2, 3, 4, 5],
                select_disabled: false,
                loading: true,
                reloadComponent: 0,
                AsientosValidos: false
            }
        },
        methods: {
            volver() {
                this.$emit('volver');
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            close(modal) {
                this.$modal.hide(modal);
            },
        },
        components: {
            ImagenPanoramica
        }
    }
</script>